module.exports = __webpack_public_path__ + "img/Mark Shirey.6c18fdff.jpg";